import React, { FC } from 'react'
import { scalePoint } from 'd3-scale'
import { Grid, StyledEngineProvider } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { Chart, ArgumentAxis, ValueAxis, AreaSeries, LineSeries } from '@devexpress/dx-react-chart-material-ui'
import { ArgumentScale, Animation } from '@devexpress/dx-react-chart'
import { IChartData } from '../../pages/Trading/tradingList'

const useStyles = makeStyles((theme: Theme) => ({
  chart: {
    paddingBottom: theme.spacing(0),
    // stroke: 'rgba(255, 255, 255, 0.16)',
    stroke: theme.palette.primary.light,
    opacity: 0.6,
    '& #center-container': {
      width: 'inherit',
    },
    '& > div': {
      width: 'inherit',
      border: 'none',
      position: 'relative',
    },
  },
  area: {
    border: '1px solid rgba(255, 255, 255, 0.16)',
    opacity: 0.6,
  },
  valueAxis: {
    fill: theme.palette.primary.light,
    opacity: 0.6,
    fontSize: 12,
  },
  grid: {
    stroke: 'rgba(255, 255, 255, 0.16)',
    opacity: 0.6,
  },
  line: {
    strokeWidth: 1,
  },
}))

// eslint-disable-next-line
const ArgumentLabel = (props: any) => {
  const classes = useStyles()
  return <ValueAxis.Label {...props} className={classes.valueAxis} />
}

// eslint-disable-next-line
const ValueLabel = (props: any) => {
  const classes = useStyles()
  const { text } = props
  return <ValueAxis.Label {...props} text={text.replace(/[^0-9,.]/g, '')} className={classes.valueAxis} />
}

// eslint-disable-next-line
const GridVertical = (props: any) => {
  const classes = useStyles()
  return <ValueAxis.Grid {...props} className={classes.grid} />
}

// eslint-disable-next-line
const GridHorizontal = (props: any) => {
  const classes = useStyles()
  return <ValueAxis.Grid {...props} className={classes.grid} />
}

// eslint-disable-next-line
const Line = (props: any) => {
  const classes = useStyles()
  return <LineSeries.Path {...props} className={classes.line} />
}

// eslint-disable-next-line
const Area = (props: any) => {
  const classes = useStyles()
  return <AreaSeries.Path {...props} className={classes.area} />
}
interface ChartAreaProps {
  dataChart: IChartData[]
}

export const ChartArea: FC<ChartAreaProps> = ({ dataChart }) => {
  const classes = useStyles()

  return (
    <StyledEngineProvider injectFirst>
      <Grid className={classes.chart}>
        <Chart data={dataChart}>
          <ArgumentScale factory={scalePoint} />
          <ArgumentAxis
            showGrid
            showLine={false}
            showTicks={false}
            labelComponent={ArgumentLabel}
            gridComponent={GridVertical}
          />
          <ValueAxis
            /* showGrid={false} */
            labelComponent={ValueLabel}
            gridComponent={GridHorizontal}
          />

          <AreaSeries
            name="buyArea"
            valueField="buy"
            argumentField="timestamp"
            color="rgba(81,229,165,0.13)"
            seriesComponent={Area}
          />
          <LineSeries
            name="buyLine"
            valueField="buy"
            argumentField="timestamp"
            color="rgba(81,229,165)"
            seriesComponent={Line}
          />

          <AreaSeries name="sellArea" valueField="sell" argumentField="timestamp" color="rgba(217, 106, 106, 0.13)" />
          <LineSeries
            name="sellLine"
            valueField="sell"
            argumentField="timestamp"
            color="rgba(217, 106, 106)"
            seriesComponent={Line}
          />

          <Animation />
        </Chart>
      </Grid>
    </StyledEngineProvider>
  )
}
